import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatorAdminService } from '../../services/operator-admin/operator-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionService } from '../../services/permission/permission.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-oa-admin-req',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './oa-admin-req.component.html',
  styleUrl: './oa-admin-req.component.scss',
})
export class OaAdminReqComponent implements OnInit {
  pending: any[] = [];
  confirmed: any[] = [];
  isLoading: boolean = false;
  canLock: boolean = false;
  canRollbackAll: boolean = false;

  constructor(
    private operatorAdminService: OperatorAdminService,
    private toastService: ToastService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.canLock = this.permissionService.can('admin-requisitions', 'can_lock');
    this.canRollbackAll = this.permissionService.can('admin-requisitions', 'can_rollback_all');
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.operatorAdminService.listPending().subscribe({
      next: (res: any) => {
        this.pending = res?.data?.requisitionDetails || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.pending = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load pending requisitions.');
      },
    });
    this.operatorAdminService.listConfirmedToCancel().subscribe({
      next: (res: any) => (this.confirmed = res?.data?.requisitionDetails || []),
      error: (err) =>
        this.toastService.error(err?.error?.message || 'Failed to load confirmed-to-cancel list.'),
    });
  }

  open(row: any): void {
    this.isLoading = true;
    this.operatorAdminService.openRequisition(row.requisitionId).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Requisition opened.');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to open requisition.');
      },
    });
  }

  bulkRollback(): void {
    this.isLoading = true;
    this.operatorAdminService.bulkRollbackAll().subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Aged locks rolled back.');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Bulk rollback failed.');
      },
    });
  }
}
